<template>
  <section class="edit-individual" v-if="child">
    <form data-vv-scope="creds">
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="name"
            v-validate="'required|max:150'"
            :error-messages="errors.collect('creds.name')"
            label="Name"
            data-vv-name="name"
            data-vv-as="name"
            required
          />
        </v-col>
      </v-row>
    </form>
    <v-row justify="end">
      <v-btn
        :loading="loading"
        @click="deleteIndividual"
        color="red darken-1"
        dark
      >
        Delete
      </v-btn>
      <v-btn
        @click="updateIndividual"
        :disabled="!hasChanged"
        :loading="loading"
        color="primary"
        class="ml-3"
      >
        Update
      </v-btn>
    </v-row>
  </section>
</template>
<script>
import Individual from '@/modules/individual/models/Individual'
import Parent from '@/modules/parent/models/Parent'
import { mapMutations } from 'vuex'

export default {
  name: 'EditIndividual',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      name: null,
      visible: false,
      loading: false,
      hasChanged: false
    }
  },
  props: {
    individualId: {
      type: String,
      required: true
    }
  },
  watch: {
    name(val) {
      if (val != this.child.first_name) this.hasChanged = true
    },
    child(val) {
      this.name = val.first_name
    }
  },
  async mounted() {
    await Individual.dispatch('fetchChildForParent', this.individualId)
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async deleteIndividual() {
      this.loading = true
      let answer = confirm(
        'Deleting a user is not reversible, all data will be lost'
      )
      if (!answer) return

      try {
        await Parent.dispatch('deleteChildren', this.individualId)
        this.showSnackbar('The account was deleted.')
      } catch (error) {
        this.showErrorSnackbar('Something bad happened. Try again')
      }
      this.loading = false
      this.$emit('close')
    },
    async updateIndividual() {
      let result = await this.$validator.validateAll('creds')
      if (!result) {
        return // there are errors
      }
      this.loading = true
      const payload = {
        id: this.individualId,
        name: this.name
      }

      try {
        await Parent.dispatch('updateChildInfo', {
          payload: payload
        })
        Individual.update({
          id: this.individualId,
          first_name: this.name
        })
        this.password = ''
        this.passwordConfirmation = ''

        this.hasChanged = false
        this.showSnackbar('Name updated successfuly.')
      } catch (error) {
        this.showErrorSnackbar('Something bad happened. Try again')
      }
      this.loading = false
    }
  },
  computed: {
    child() {
      return Individual.find(this.individualId)
    }
  }
}
</script>

<style lang="scss">
.edit-individual {
}
</style>
